(function() {
  function changeTranslations(boxElRoot) {
    const selectEls = boxElRoot.querySelectorAll('.combowise__input--select-select');

    for (let i = 0; i < selectEls.length; i++) {
      let txt = selectEls[i].options[0].text;
      if (txt == 'Select tamanho') {
        selectEls[i].options[0].text = 'Selecione o tamanho';
      } else if (txt = 'Select cor') {
        selectEls[i].options[0].text = 'Selecione a cor';
      }
    }
  }
  
  const i = setInterval(function() {
    const boxElRoot = document.querySelector('.combowise-box');

    if (boxElRoot) {
      clearInterval(i);

      changeTranslations(boxElRoot);
    }
  }, 1000);
})();